module.exports = __webpack_public_path__ + "static/media/2025-Summer-of-Cricket-Logged-In-308x280.2a77fc29.png";